module.exports = __webpack_public_path__ + "assets/img/placeholder/next-768x432.jpg";